@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';

.delivery-expectation-text {
  background-color: var(--grey-300);
  border-radius: @space-4;
  padding: @space-8;
  margin-right: @space-8;
}

.or-text {
  margin-right: @space-8;
}
